/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect } from "react";
import { LayoutWrapper } from "layout/layout-wrapper";
import { useFetchWebpage } from "@simplicitycms/simplicity-common";
import { useSimpliCityPath } from "@simplicitycms/simplicity-common";
import { EnvWrapper } from "cms/auth/components/env-wrapper.jsx";
// import { EnvWrapper } from "@simplicitycms/simplicity-common";
// import { RemoveTrailingSlash } from "../remove-trailing-slash";

const Webpage = () => {

    const { fetchWebpageDataComplete } = useFetchWebpage();
    const { path } = useSimpliCityPath();

    useEffect(() => {
        if (path) {
            fetchWebpageDataComplete(path);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path]);

    return (
        <>
            <EnvWrapper>
                <LayoutWrapper />
            </EnvWrapper>
        </>
    );
};

export { Webpage };
